import script from "./FooterShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterShowcase.vue?vue&type=script&setup=true&lang=js"

import "./FooterShowcase.vue?vue&type=style&index=0&id=0cbf3439&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cbf3439"]])

export default __exports__